import { sharedStyles } from '../../styles/shared-styles';
import { css, html, LitEntity, renderIf } from '../../utility/lit-entity';
import '../../common/bn-surface';
import './organization-add-child-action';

class OrganizationAddChild extends LitEntity {
  constructor() {
    super();
    this.successtext = 'Organization has been added.';
  }

  static get properties() {
    return {
      selected: { type: String, attribute: false },
      successtext: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-surface {
        margin: 8px 0 0 0;
      }
    `];
  }

  render() {
    const { entity } = this;
    if (!entity) {
      return html``;
    }

    const actions = this.entity.getActionsByClass('create-organization');

    return html`
      ${renderIf(actions.length > 1, html`
        <h3>Choose Organization Type</h3>
        <select @input="${this._onSelectOption}">
          <option value="none">---</option>
          ${actions.map(this._renderOrganizationOption, this)}
        </select>
      `)}

      ${this._renderSelectedAction(actions)}
    `;
  }

  _onSelectOption() {
    this.selected = this.shadowRoot.querySelector('select').value;
  }

  _renderOrganizationOption({ name, title }) {
    return html`
      <option value="${name}" ?selected="${this.selected === name}">${title}</option>
    `;
  }

  _renderSelectedAction(actions) {
    const selectedAction = actions.length === 1 ? actions[0] : actions.find((action) => this.selected === action.name);
    if (!selectedAction) {
      return html``;
    }

    return html`
      <bn-surface>
        <organization-add-child-action
          .href="${this.href}"
          .actionname="${selectedAction.name}"
          submittext="Add"
          successtext=${this.successtext}
          errortext="Could not add organization."
        >
          <h3 slot="header">${selectedAction.title}</h3>
        </organization-add-child-action>
      </bn-surface>
    `;
  }
}

window.customElements.define('organization-add-child', OrganizationAddChild);
